export default "__VITE_ASSET__DZGO3puW__"